document.addEventListener("DOMContentLoaded", function() {
  const relatedSection = document.querySelector("#shopify-section-template--23286231302501__related-products");
  if (!relatedSection) return;

  const productRecommendations = relatedSection.querySelector("product-recommendations.related-products");
  if (!productRecommendations) return;

  // Function to check if there are any products
  const checkProducts = () => {
    const productList = productRecommendations.querySelector("ul.product-grid");
    if (!productList) return;

    const items = productList.querySelectorAll("li.grid__item");
    if (items.length === 0) {
      relatedSection.style.display = "none"; // no products
    } else {
      relatedSection.style.display = ""; // show section if products exist
    }
  };

  // Initial check
  checkProducts();

  // Observe for class changes or child nodes (Shopify injects products dynamically)
  const observer = new MutationObserver(checkProducts);
  observer.observe(productRecommendations, { childList: true, subtree: true, attributes: true });
});
